<app-dropdown
  class="dropdown"
  [control]="control"
  [iconName]="'globe'"
  [label]="'@components.languageSelector.label' | translate"
  [placeholder]="'@components.languageSelector.placeholder' | translate"
  [isMarkedAsRequired]="false"
  [model]="languageDropdownModel"
></app-dropdown>
